module.exports = __webpack_public_path__ + "media/project_quote/email-a55f3170.png";